import { Group } from '@visx/group'
import { Line, Polygon } from '@visx/shape'
import cx from 'classnames'

import {
  REPLACEMENT_LINE_X_COORDINATE,
  TRIANGLE_HEAD_RADIUS,
} from './constants'
import type { Coordinate } from './types'

type Props = {
  from: Coordinate
  to: Coordinate
  isActive: boolean
}

export const ReplacementPath = ({ from, to, isActive }: Props) => (
  <Group className={cx('group/replacement-path', { active: isActive })}>
    <Line
      className="stroke-inheritance stroke-2 group-hover/replacement-path:stroke-3 group-[.active]/replacement-path:stroke-3"
      from={from}
      to={{ x: REPLACEMENT_LINE_X_COORDINATE, y: from.y }}
    />
    <Line
      className="stroke-inheritance stroke-2 group-hover/replacement-path:stroke-3 group-[.active]/replacement-path:stroke-3"
      from={{ x: REPLACEMENT_LINE_X_COORDINATE, y: from.y }}
      to={{ x: REPLACEMENT_LINE_X_COORDINATE, y: to.y }}
    />
    <Line
      className="stroke-inheritance stroke-2 group-hover/replacement-path:stroke-3 group-[.active]/replacement-path:stroke-3"
      from={{ x: REPLACEMENT_LINE_X_COORDINATE, y: to.y }}
      to={to}
    />
    <Polygon
      sides={3}
      className="fill-inheritance stroke-inheritance stroke-2 group-hover/replacement-path:stroke-3 group-[.active]/replacement-path:stroke-3"
      size={TRIANGLE_HEAD_RADIUS}
      center={{
        y: to.y,
        x: to.x - TRIANGLE_HEAD_RADIUS,
      }}
    />
  </Group>
)
